import { render, staticRenderFns } from "./CustomerInformation.vue?vue&type=template&id=a60febfe&scoped=true"
import script from "./CustomerInformation.vue?vue&type=script&lang=ts"
export * from "./CustomerInformation.vue?vue&type=script&lang=ts"
import style0 from "./CustomerInformation.vue?vue&type=style&index=0&id=a60febfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60febfe",
  null
  
)

export default component.exports